import { waitForDOMContentLoaded } from "../utils/async-utils";
import { easeOutExpo } from "../utils/easing";
const MENU_ANIMATION_DURATION_MS = 500;

export class MenuAnimationSystem {
  constructor() {
    this.components = [];
    this.data = new Map();
    this.tick = this.tick.bind(this);
    waitForDOMContentLoaded().then(() => {
      this.viewingCameraEl = document.getElementById("viewing-camera");
    });
  }
  register(component, menuEl, chooseScale) {
    this.components.push(component);
    this.data.set(component, {
      menuEl,
      chooseScale,
      menuOpenTime: -1,
      startScaleAtMenuOpenTime: 0,
      wasMenuVisible: false,
      endingScale: 0
    });
  }
  unregister(component) {
    this.components.splice(this.components.indexOf(component), 1);
    this.data.delete(component);
  }
  tick = (function () {
    return function tick(t) {
      if (!this.viewingCameraEl) return;

      for (let i = 0; i < this.components.length; i++) {
        const datum = this.data.get(this.components[i]);
        const isMenuVisible = datum.menuEl.object3D.visible;
        const isMenuOpening = isMenuVisible && !datum.wasMenuVisible;

        if (isMenuOpening) {
          // Always use fixed scale of 1
          datum.endingScale = 1;
          datum.menuOpenTime = t;
          datum.startScaleAtMenuOpenTime = 0.01; // Start from near-zero
        }

        if (isMenuVisible) {
          const progress = THREE.MathUtils.clamp((t - datum.menuOpenTime) / MENU_ANIMATION_DURATION_MS, 0, 1);

          const currentScale = THREE.MathUtils.lerp(
            datum.startScaleAtMenuOpenTime,
            datum.endingScale,
            easeOutExpo(progress)
          );

          datum.menuEl.object3D.scale.setScalar(currentScale);
          datum.menuEl.object3D.matrixNeedsUpdate = true;
        }

        datum.wasMenuVisible = isMenuVisible;
      }
    };
  })();
}
